<template>
	<div class="account-settings page noscroll">
			<div class="header">
				<h3>Account</h3>
				<div class="right_btns layout-row">
					<v-button @click="saveUser" :loading="saving" :disabled="!changed" label="Save changes"></v-button>
				</div>
			</div>
			<div class="content scroll">
				<loading v-if="loading"></loading>
				<div class="funnel_apps_list" style="position: relative;">
					<div class="">
						<h3 class="brdr_content_title df">Basic details</h3>

						<div class="margin-t-25">
							<input-field label="Business name" placeholder="Your business name"
							             v-model="userData.business_name" @input="changed=true"/>

							<input-field class="margin-t-15" label="Account primary email"
							             v-model="userData.email" readonly />
						</div>

						<timezone-popup v-if="timezoneOpen" @close="timezoneOpen=false"
						                @done="timezoneOpen=false;userData.time_zone=$event" />

						<div class="layout-row clickable-section" style="margin-top: 20px;" @click="timezoneOpen=!timezoneOpen">
							<div class="flex">
								<p style="font-weight: 600;">Your account timezone</p>
								<p>
									This will be the timezone used to render your analytics charts and tables. It defaults to "UTC" if not set.
								</p>
							</div>
							<div class="flex" style="max-width: 200px;">
							</div>
							<div class="flex-none right-panel" style="min-width: 200px">
					      <span v-if="userData.time_zone">
						      <b>{{ userData.time_zone }}</b>
					      </span>
								<span v-else style="color: grey;font-style: italic;">
						      UTC
					      </span>
							</div>
						</div>

					</div>

					<subdomain-settings class="margin-t-25"/>

					<div class="margin-t-25">
						<h3 class="brdr_content_title df">Payment settings</h3>

						<input-field class="margin-b-20" label="Default PayPal business ID/email (legacy)"
						             v-model="userData.default_paypal_business_id" @input="changed=true"/>

						<div class="form-group with_top_block">
							<span class="form_group_top_block">Default currency</span>

							<v-select label="text" :reduce="x=>x.id" :clearable="false" :searchable="true"
							          :options="selectCurrencyOptions" v-model="userData.default_currency_code"
							          append-to-body @input="changed=true">
								<template v-slot:option="option">
									<span v-html="option.text"></span>
								</template>
								<template v-slot:selected-option="option">
									<span v-html="option.text"></span>
								</template>
							</v-select>

						</div>
					</div>

					<div class="api-panel margin-t-25 margin-b-30">
						<h3 class="brdr_content_title df">API credentials</h3>
						<span class="desc">
		                Copy the following API Key into your Zapier integration to connect it to Funnelish.
	                </span>
						<div class="api-panel-inner">
							<input-field readonly is-copy select-all class="flex" label="Private API Key"
							             v-model="userData.private_api_key"></input-field>
							<div style="width: 15px"></div>
							<v-button border class="reset-key-btn flex-none" label="Reset Key"
							          @click="resetApiKey" :loading="resetingApiKey"/>
						</div>
						<span class="note">
		                <b style="color: red">*</b> Keep this API Key safe and do not share it.
	                </span>
					</div>

				</div>
			</div>

	</div>
</template>

<script>
import API from "@/api";
import currencies from "@/helpers/currencies"
import MainSearch from "@/components/MainSearch.vue";
import InputField from "@/components/base/input-field";
import VButton from "@/components/base/v-button";
import Popup from "@/components/base/popup";
import Loading from "@/components/Loading";
import SubdomainSettings from "@/views/subdomain-settings";
import TimezonePopup from "@/components/popups/timezone-popup";

export default {
	name: 'accountSettings', title: "Account | Funnelish™", components: {
		TimezonePopup,
		SubdomainSettings, Loading, Popup, VButton, InputField, MainSearch
	}, mixins: [API], data() {
		return {
			changed: false,
			timezoneOpen: false,
			resetingApiKey: false,
			selectCurrencyOptions: currencies,
			saved: false,
			loading: false,
			saving: false,
			currencies: currencies,
			userData: {
				"type": "users", "id": "", "attributes": {}
			}
		}
	}, computed: {
		user(){
			return this.$store.state.userInfo;
		},
		notificationsOpen() {
			return this.$store.state.notificationsOpen;
		}, trackingCode() {
			return 'code';
		},
	}, methods: {
		async saveUser() {
			try {
				this.saving = true;
				delete this.userData.last_activity_insert;
				delete this.userData.last_dashboard_update;
				delete this.userData.member.password;
				delete this.userData.member.v_code;
				delete this.userData.verified;
				delete this.userData.created_at;

				var savedRes = await this.api.users.patch(this.userData.id, this.userData);
				if (savedRes.error)
					throw savedRes;
				else
					this.saved = true;

				this.$notify({
					group: 'main', title: "Your changes were saved successfully.", type: 'info',
				});
				this.changed = false;
			} catch (e) {
				this.$error(e)
			} finally {
				this.saving = false;
			}
		}, async resetApiKey() {
			try {
				if (!confirm("Are you sure you want to regenerate your Private API Key?")) return;

				this.resetingApiKey = true;

				let resp = await this.api.users.resetApiKey();
				if (resp.error || resp.status !== 'OK') throw resp
				this.$info(null, "Your Private API Key regenerated, make sure to update integrations using the old API Key.");
				window.location.reload();
			} catch (e) {
				this.$error(e);
			} finally {
				this.resetingApiKey = false;
			}
		}, notifToggle: function () {
			this.$store.dispatch('notificationsOpenToggle');
		},
		async init() {
			try {
				this.loading = true;
				let userRes = await this.api.users.get();
				this.userData = userRes
				this.changed = false;
			} catch (e) {
				console.error("error", e)
			} finally {
				this.loading = false;
			}
		}, copyToClipboard(queryElem) {
			let elemToCopy = document.querySelector(queryElem);
			elemToCopy.setAttribute('type', 'text');
			elemToCopy.select();

			try {
				var successful = document.execCommand('copy');

			} catch (err) {
				console.log('Oops, unable to copy');
			}

			elemToCopy.setAttribute('type', 'hidden')
			window.getSelection().removeAllRanges()
		},
	}, mounted() {
		this.init()
	}
}
</script>
<style scoped lang="scss">
.header {
	border-bottom: 1px solid $light-grey;
	border-radius: 0 0 0 0;
}
.funnel_apps_list {
	padding: 35px 40px 80px;
}
.clickable-section {
	.right-panel {
		margin: auto;
		color: #57585D;
		font-size: 14px;
		b {
			//color: black;
		}
	}
}
.fields-container {
	.input-field {
		margin-top: 20px;
	}
}

.api-panel {
	.api-panel-inner {
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	.desc {
		margin: 20px 0;
		display: flex;
	}

	.note {
		margin: 5px;
		display: block;
	}

	.reset-key-btn {
		width: auto;
		white-space: nowrap;
		height: 30px;
		padding: 6px 20px;
		font-size: 12px;
	}
}
</style>
